import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import FeatureName from "../../visComponents/featureName";
import {getCartItemUnit, getFeatureGroupName, getFeatureUnit, toFixedPrice} from "../../../misc/helpers";
import MaterialsWizardFooterStepThumbnail from "../../qkbPages/materialsWizard/materialsWizardFooterStepThumbnail";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";

const WizardConflictPopupCartItem = (props) => {

  const {cartItem, intl, fabricatorData, wizardSelectedValues} = props;

  let groupName = null;
  let featureGroup = null;
  if (cartItem.cartFeature.getParent) {
    featureGroup = cartItem.cartFeature.getParent();
    groupName = getFeatureGroupName(featureGroup, intl, fabricatorData)
  }
  const wizardSelectedKey = Object.keys(wizardSelectedValues).find(wizKey => {
    return wizardSelectedValues[wizKey].wizardGroup && (wizardSelectedValues[wizKey].wizardGroup.id === cartItem.fromWizardGroupId)
  });
  const wizardSelectedValue = wizardSelectedKey ? wizardSelectedValues[wizardSelectedKey] : null;

  // console.log("wizardSelectedValue", wizardSelectedValue);

  const featureUnit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity);
  const cartItemUnit = getCartItemUnit(cartItem, intl);
  const unit = cartItemUnit ? cartItemUnit : featureUnit;

  return (
    <li className="apply-popup-item" key={cartItem.id}>
      <div className="table">
        <div className="apply-popup-item__image apply-popup-item__image--small">
          {wizardSelectedValue || featureGroup ? (
            <MaterialsWizardFooterStepThumbnail wizardGroup={wizardSelectedValue ? wizardSelectedValue.wizardGroup : null}
                                                featureGroup={featureGroup}
                                                wizardSelectedValue={wizardSelectedValue}/>
          ) : null}
        </div>
        <div className="apply-popup-item__main">
          <p className="apply-popup-item__main-title">
            {groupName ? groupName + " - " : null}<FeatureName feature={cartItem.cartFeature}/>
          </p>
          {cartItem.partId === "room" ? null : (
            <p className="apply-popup-item__main-description">
              {unit}: {toFixedPrice(parseFloat(cartItem.displayFakeQuantity) === cartItem.displayFakeQuantity
              ? cartItem.displayFakeQuantity
              : cartItem.quantity)}
            </p>
          )}
        </div>
      </div>
    </li>
  )
}

WizardConflictPopupCartItem.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

const mapStateToProps = (store) => {
  const {wizardSelectedValues} = store.wizardState;
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData,
    wizardSelectedValues,
  };
};

export default injectIntl(
  connect(mapStateToProps)(WizardConflictPopupCartItem)
)
